import styled from "@emotion/styled";
import { TABLET_QUERY_MAX_WIDTH } from "constants/vp-sizes";
export const StyledScrollTopFabComponent = styled.div`
  position: fixed;
  right: 36px;
  bottom: 36px;

  width: 60px;
  height: 60px;
  background: #e6e9ef;
  box-shadow: 0 2px 4px 1px rgba(0, 0, 0, 0.25);

  z-index: 9999;

  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  transition: opacity 0.2s ease;
  opacity: 0;

  &.is-shown {
    opacity: 1;
  }

  &.tooltip-trigger {
    .tooltip-contents {
      display: none;
      opacity: 0;
      transition: opacity 0.2s ease;

      position: absolute;
      left: 50%;
      bottom: calc(100% + 16px);
      transform: translateX(-50%);

      width: 110px;
      padding: 7px 0;
      border-radius: 5px;

      color: #ffffff;
      background: #676879;

      font-size: 0.731rem;
      line-height: 13px;
      text-align: center;
      letter-spacing: -0.02em;
    }

    &:hover {
      .tooltip-contents {
        display: block;
        opacity: 1;
      }
    }
  }

  &:hover {
    cursor: pointer;
    background: #e6e9ef;
    box-shadow: 0 2px 4px 1px rgba(0, 0, 0, 0.25);
  }

  @media (max-width: ${TABLET_QUERY_MAX_WIDTH}) {
    right: 24px;
    bottom: 24px;

    &.tooltip-trigger:hover {
      .tooltip-contents {
        display: none;
        opacity: 0;
      }
    }
  }
`;
